<template>
  <error-page-content
    :title="$t('errors.organizationNotFound')"
    :error-code="errorCode"
    :status="404"
  >
    <template #icon>🤷‍♂️</template>
    <template #default></template>
  </error-page-content>
</template>

<script setup lang="ts">
import ErrorPageContent from "@core/errors/ErrorPageContent.vue";

const { errorCode = "not_found" } = defineProps<{
  errorCode?: string;
}>();
</script>

<style lang="scss">
.view-notfound {
  display: flex;
  place-items: center;
  padding: 1rem;

  &__text {
    margin: auto;
    text-align: center;
  }

  &__link {
    display: block;
    text-align: center;
    font-size: 1.5rem;
    margin-top: 1rem;
  }
}
</style>
